<template>
    <header class="header">
        <h1 class="logo hideOnLaptop" :class="{ show: show }">MailPal</h1>
        <div class="nav">
            <ul class="nav-list">
                <li class="hideOnMobile">
                    <a href="#overview">Overview</a>
                </li>
                <li class="hideOnMobile">
                    <a href="#features">Features</a>
                </li>
                <li class="hideOnMobile">
                    <a href="#pricing">Pricing</a>
                </li>
                <li class="hideOnMobile">
                    <a href="/signup">Sign up</a>
                </li>
                <li class="standout">
                    <a href="/login">Login</a>
                </li>
            </ul>
        </div>
    </header>
</template>

<script>
  export default {
    name: 'Header',
    data(){
        return {
            show: false
        }
    },
    methods: {
        handleScroll: function (){
            if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
                this.show = true;
            } else {
                this.show = false;
            }
        }
    },
    computed: {
        mobile: function(){
            return this.$store.state.mobile;
        },
    },
    created (){
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    }
  }
</script>

<style scoped>
    .header{
        padding: 25px 25px;
        overflow: hidden;
    }

    .header h1{
        float: left;
        margin: 0;
    }

    .standout{
        display: none;
    }

    .nav{
        float: right;
    }

    .nav-list{
        list-style-type: none;
        margin: 0;
        padding: 0;
        height: 100%;
        display: flex;
        align-items: center;
    }

    .nav-list li {
        float: left;
        margin-left: 1rem;
        margin-right: 1rem;
        padding: 10px 10px;
        font-size: 18px;
    }

    .nav-list a{
        text-decoration: none;
        color: var(--font);
        font-weight: 700;
    }

    .logo{
        transition: 0.2s ease-in-out;
        -webkit-transition: 0.2s ease-in-out;
        -moz-transition: 0.2s ease-in-out;
        -o-transition: 0.2s ease-in-out;
        opacity: 0;
        transform: translateY(-40px);
        position: fixed;
        z-index: 1;
    }

    .show{
        opacity: 1;
        transform: translateY(0px);
    }

    @media only screen and (max-width: 1300px) {
        .hideOnLaptop{
            display: none;
        }
    }

    @media only screen and (max-width: 900px) {
        .nav-list li {
            margin-right: 5px;
            padding: 5px 5px;
            font-size: 15px;
        }

        .hideOnLaptop{
            display: none;
        }
    }

    @media only screen and (max-width: 700px) {
        .hideOnMobile {
            display: none;
        }

        .standout{
            display: block;
            background: var(--orange);
            border-radius: 5px;
            padding: 10px 25px !important;
            cursor: pointer;
        }
    }
</style>